export default __webpack_public_path__ + "static/media/feather _ chevron-double.9c6c3abe.svg";